import { IBaseEntity, IBaseQuery } from './common.type';

export interface IKey extends IBaseEntity {
  partner?: EKeyPartner;
  app_key?: string;
  api_key?: string;
  title?: string;
  note?: string;
}

export interface IKeyBody {
  title: string;
  note?: string;
  partner: EKeyPartner;
  apiKey?: string;
  appKey?: string;
}

export interface IKeyQuery extends IBaseQuery {
  partner?: EKeyPartner;
}

export enum EKeyPartner {
  VIETTEL = 'VIETTEL',
  FPT = 'FPT',
  VBEE = 'VBEE',
  FREE = 'FREE',
}
